import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import Moment from 'moment';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import swal from 'sweetalert2';
import api from 'lib/api';
import { addError } from 'actions';
import { createAssessments, updateAssessment, updateAssessmentStatus } from 'actions/assessments';
import { getRootUrl } from 'helpers/url';
import SimpleSelect from 'components/Inputs/SimpleSelect';
import StudentAssessorSelect from 'components/Inputs/StudentAssessorSelect';
import AssessmentForm from 'containers/Forms/AssessmentForm';
import Modal from 'containers/Modals/Modal';
import ClearBlockAssessments from 'containers/Forms/Assessment/ClearBlockAssessments';
import AssessmentsConsumer from 'components/BlockAssessments/Consumer';
import { isUserTeacher } from 'helpers/user';
import { Icon, Checkbox, Button } from '@haldor/ui';
import { Spinner } from 'UI';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';

var UserAssignment = /*#__PURE__*/function (_Component) {
  _inherits(UserAssignment, _Component);

  var _super = _createSuper(UserAssignment);

  function UserAssignment(props) {
    var _this;

    _classCallCheck(this, UserAssignment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "closeAssessment", function (skipPrompt) {
      if (skipPrompt) {
        _this.props.reload(false);

        _this.setState({
          assessmentOpen: false
        });
      } else {
        _this.setState({
          assessmentOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLocked", function (selectedUsers, lock) {
      var assignmentId = _this.props.assignment.id;
      var addPermissons = [];
      var permissionData = [];
      selectedUsers.forEach(function (element) {
        return element.assignmentTaskAssignees.map(function (task) {
          permissionData.push(task);

          if (lock) {
            if (task.permission !== '0') {
              addPermissons.push(task);
            }
          } else if (task.permission === '0') {
            addPermissons.push(task);
          }
        });
      });

      if (addPermissons.length > 0) {
        _this.setState({
          permissionLoading: true
        });

        var tasks = _this.props.assignment.tasks;

        if (lock) {
          api["delete"]("assignments/".concat(assignmentId, "/workspacepermissions"), addPermissons).then(function (response) {
            tasks.map(function (items) {
              var object = response.data.find(function (x) {
                return x.assignmentTaskId === items.id;
              });

              if (object) {
                items.assignmentTaskAssignees = [object];
              }
            });
            var newObject = _this.props.assignment;
            newObject.tasks = tasks;

            _this.props.assignment.tasks.forEach(function (t) {
              return t.selected = false;
            });

            _this.setState({
              allSelected: false,
              permissionLoading: false
            });
          })["catch"](function () {
            _this.setState({
              allSelected: false,
              permissionLoading: false
            });

            _this.props.assignment.tasks.forEach(function (t) {
              return t.selected = false;
            });
          });
          return;
        }

        api.put("assignments/".concat(assignmentId, "/workspacepermissions"), addPermissons).then(function (response) {
          tasks.map(function (items) {
            var object = response.data.find(function (x) {
              return x.assignmentTaskId === items.id;
            });

            if (object) {
              items.assignmentTaskAssignees = [object];
            }
          });
          var newObject = _this.props.assignment;
          newObject.tasks = tasks;

          _this.props.assignment.tasks.forEach(function (t) {
            return t.selected = false;
          });

          _this.setState({
            allSelected: false,
            permissionLoading: false
          });
        })["catch"](function () {
          _this.setState({
            allSelected: false,
            permissionLoading: false
          });

          _this.props.assignment.tasks.forEach(function (t) {
            return t.selected = false;
          });
        });
      } else {
        _this.setState({
          allSelected: false
        });

        _this.props.assignment.tasks.forEach(function (t) {
          return t.selected = false;
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openAssessment", function (user) {
      if (user != null) {
        _this.props.assignment.tasks.forEach(function (t) {
          return t.selected = false;
        });

        user.selected = true;
      } else {
        _this.props.assignment.tasks.forEach(function (student) {
          var assessment = _this.props.assessments.find(function (t) {
            return t.studentId == student.assignedTo && t.assessorType == ASSESSMENT_TYPES.TEACHER;
          });

          if (assessment != null) {
            student.selected = false;
          }
        });
      }

      var selectedUsers = _this.props.assignment.tasks.filter(function (t) {
        return t.selected;
      });

      if (selectedUsers.length > 0) {
        _this.setState({
          assessmentOpen: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentSubmit", function (values) {
      return new Promise(function (resolve) {
        if (values.id != null) {
          var existing = _this.props.assessments.find(function (assessment) {
            return assessment.id == values.id;
          });

          _this.props.updateAssessment(values, existing).then(function () {
            resolve(1);

            _this.closeAssessment(true);
          });

          return true;
        }

        var selectedTasks = _this.props.assignment.tasks.filter(function (t) {
          return t.selected;
        });

        var data = [];
        selectedTasks.forEach(function (task) {
          data.push(_objectSpread(_objectSpread({}, values), {}, {
            assignmentId: _this.props.assignment.id,
            referenceId: task.id,
            studentId: task.assignedTo
          }));
        });

        _this.props.createAssessments(data).then(function () {
          resolve(1);

          _this.closeAssessment(true);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openStudentAssessment", function (user, selectedAssessment) {
      _this.setState({
        assessTask: user,
        selectedAssessment: selectedAssessment
      }, function () {
        _this.setState({
          studentAssessmentOpen: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeStudentAssessment", function (event, skipPrompt) {
      if (skipPrompt) {
        _this.setState({
          studentAssessmentOpen: false
        });
      } else {
        _this.setState({
          studentAssessmentOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusSelect", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                item.disabled = true;

                _this.setState({});

                api.put('assignments/Student/Status?assignmentTaskId=' + item.id + '&status=' + value.value).then(function (response) {
                  _this.props.addError(_this.props.translate('changes-saved'), 'info');

                  item.disabled = false;
                  item.status = value.value;

                  _this.setState({});
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onAssessmentStatusSelect", function (item, value) {
      var assessment = _this.props.assessments.find(function (t) {
        return t.studentId == item.assignedTo && t.assessorType == ASSESSMENT_TYPES.TEACHER;
      });

      if (assessment != null) {
        _this.props.updateAssessmentStatus(assessment.id, value.value).then(function () {
          _this.props.addError(_this.props.translate('changes-saved'), 'info');
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (user, checked) {
      user.selected = checked;

      _this.setState({});
    });

    _defineProperty(_assertThisInitialized(_this), "onCheckAll", function (checked) {
      _this.props.assignment.tasks.forEach(function (t) {
        return t.selected = checked;
      });

      _this.setState({
        allSelected: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentAssessorChange", function (event, user) {
      api.put("assignments/task/".concat(user.id, "/studentassessor/").concat(event), null).then(function (response) {
        var _user$assessmentTypeR;

        _this.props.addError(_this.props.translate('student-assessor-saved'), 'info'); //should update all the assessment type relation records which are peer assessments


        (_user$assessmentTypeR = user.assessmentTypeRelationships) === null || _user$assessmentTypeR === void 0 ? void 0 : _user$assessmentTypeR.forEach(function (s) {
          if (s.assessmentType == ASSESSMENT_TYPES.PEER) {
            s.assessor = event;
          }
        });
        user.studentAssessorId = event;

        _this.setState({});
      });
    });

    _defineProperty(_assertThisInitialized(_this), "markForConversation", function (task) {
      var student = task.students[0];

      if (_this.props.onConversation != null) {
        _this.props.onConversation(student);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "publishAllAssessments", function () {
      var _this$props = _this.props,
          addError = _this$props.addError,
          translate = _this$props.translate,
          assessments = _this$props.assessments;
      var tasks = _this.props.assignment.tasks;
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('publish-all-assessments-warning'),
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('yes-publish')
      }).then(function (result) {
        if (result.value != null) {
          var requests = 0;
          tasks.map(function (task) {
            if (task.status == 'ASSIGNMENT_TASK_SUBMITTED' || task.status == 'ASSIGNMENT_TASK_NOT_COMPLETE' || task.status == 'ASSIGNMENT_TASK_CAN_DEVELOP') {
              var userAssessment = assessments.find(function (ass) {
                return ass.referenceId == task.id;
              });

              if (userAssessment != null) {
                if (userAssessment.status != 'ASSESSMENT_PUBLISHED') {
                  requests++;
                  api.put("assessments/status?assessmentId=".concat(userAssessment.id, "&status=ASSESSMENT_PUBLISHED"), null).then(function () {
                    requests--;

                    if (requests == 0) {
                      addError(translate('changes-saved'), 'info');

                      _this.props.reload(true);
                    }
                  });
                }
              }
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openRandomizeStudentAssessors", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('buddy-assessment-randomize-assessor-prompt'),
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then(function (result) {
        if (result.value != null) {
          api.put("assignments/".concat(_this.props.assignment.id, "/studentassessors"), null).then(function () {
            _this.props.reload(true);

            _this.props.addError(_this.props.translate('student-assessor-saved'), 'info');
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "studentAssessmentButton", function (user) {
      var assignment = _this.props.assignment;
      var disabled = false;

      if (assignment.status == 'ASSIGNMENT_DRAFT' || user.status == 'ASSIGNMENT_TASK_STARTED' || user.status == 'ASSIGNMENT_TASK_NOT_STARTED' || user.id == -1) {
        disabled = true;
      }

      return /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: disabled,
        onClick: function onClick() {
          return _this.openAssessment(user);
        }
      }, _this.props.translate('assess'));
    });

    _defineProperty(_assertThisInitialized(_this), "renderBody", function (seperatedAssessments) {
      var tasks = _this.props.assignment.tasks;
      var rootUrl = _this.props.activeSection.classroomUrl;
      var rootUri = new URL(rootUrl);
      var segments = rootUri.pathname.split('/');
      rootUrl = rootUrl.substring(0, rootUrl.indexOf('/' + segments[1] + '/'));
      return tasks.sort(function (a, b) {
        return a.groupName.split(' ').pop().localeCompare(b.groupName.split(' ').pop());
      }).map(function (user) {
        var _this$props$assessmen2, _this$props$assessmen3, _user$assessmentTypeR2, _seperatedAssessments, _seperatedAssessments2, _seperatedAssessments3, _seperatedAssessments4, _seperatedAssessments5, _seperatedAssessments6, _seperatedAssessments7, _seperatedAssessments8;

        var teacherAssessment = null;

        if (_this.props.assessments != null) {
          var _this$props$assessmen;

          teacherAssessment = (_this$props$assessmen = _this.props.assessments.find(function (t) {
            return t.studentId == user.assignedTo && t.assessorType == ASSESSMENT_TYPES.TEACHER;
          })) !== null && _this$props$assessmen !== void 0 ? _this$props$assessmen : null;
        }

        var peerAssessment = (_this$props$assessmen2 = _this.props.assessments.find(function (t) {
          return t.studentId == user.assignedTo && t.assessorType == ASSESSMENT_TYPES.PEER;
        })) !== null && _this$props$assessmen2 !== void 0 ? _this$props$assessmen2 : null;
        var selfAssessment = (_this$props$assessmen3 = _this.props.assessments.find(function (t) {
          return t.studentId == user.assignedTo && t.assessorType == ASSESSMENT_TYPES.SELF && t.status != 'ASSESSMENT_STARTED';
        })) !== null && _this$props$assessmen3 !== void 0 ? _this$props$assessmen3 : null;
        var disabled = user.disabled;
        user.studentAssessorId = (_user$assessmentTypeR2 = user.assessmentTypeRelationships.find(function (s) {
          return s.assessmentType == ASSESSMENT_TYPES.PEER;
        })) === null || _user$assessmentTypeR2 === void 0 ? void 0 : _user$assessmentTypeR2.assessor;
        var studentAssessor = peerAssessment != null ? _this.props.assignment.tasks.find(function (t) {
          return t.assignedTo == user.studentAssessorId;
        }) : null;
        var conversation = null;

        if (_this.props.conversations != null) {
          conversation = _this.props.conversations.find(function (conv) {
            return conv.memberships.find(function (member) {
              return member.membershipID == user.assignedTo;
            });
          });
        }

        var assigmentsTask = user === null || user === void 0 ? void 0 : user.assignmentTaskAssignees;
        var locked = assigmentsTask.filter(function (x) {
          return x.permission === '0';
        }).length > 0 ? true : false;
        var linkTextVisible = ((_seperatedAssessments = seperatedAssessments.teacherAssessments) === null || _seperatedAssessments === void 0 ? void 0 : _seperatedAssessments.length) > 0 && ((_seperatedAssessments2 = seperatedAssessments.selfAssessments) === null || _seperatedAssessments2 === void 0 ? void 0 : _seperatedAssessments2.length) > 0 && ((_seperatedAssessments3 = seperatedAssessments.peerAssessments) === null || _seperatedAssessments3 === void 0 ? void 0 : _seperatedAssessments3.length) > 0;
        return /*#__PURE__*/React.createElement("tr", {
          key: user.id + user.groupName,
          className: "no-hover"
        }, /*#__PURE__*/React.createElement("td", null, !_this.props.printable ? /*#__PURE__*/React.createElement(Checkbox, {
          disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.assignment.locked,
          label: /*#__PURE__*/React.createElement("span", {
            style: {
              marginLeft: '1rem'
            }
          }, locked ? /*#__PURE__*/React.createElement(Icon, {
            name: "Lock"
          }) : null),
          value: user.selected,
          onChange: function onChange(checked) {
            return _this.onSelect(user, checked);
          }
        }) : null), /*#__PURE__*/React.createElement("td", {
          className: "name"
        }, user.groupName), /*#__PURE__*/React.createElement("td", {
          className: "status"
        }, /*#__PURE__*/React.createElement(SimpleSelect, {
          selectedValue: user.status,
          name: "user-status",
          disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.printable == true || _this.props.assignment.locked || disabled,
          item: user,
          type: "assignment",
          onChange: _this.onStatusSelect
        })), ((_seperatedAssessments4 = seperatedAssessments.teacherAssessments) === null || _seperatedAssessments4 === void 0 ? void 0 : _seperatedAssessments4.length) > 0 ? /*#__PURE__*/React.createElement("td", {
          className: "status"
        }, /*#__PURE__*/React.createElement(SimpleSelect, {
          selectedValue: teacherAssessment != null ? teacherAssessment.status : '',
          name: "assessment-status",
          disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.printable == true || _this.props.assignment.locked || disabled || teacherAssessment == null,
          item: user,
          type: "assessment",
          onChange: _this.onAssessmentStatusSelect
        })) : null, ((_seperatedAssessments5 = seperatedAssessments.teacherAssessments) === null || _seperatedAssessments5 === void 0 ? void 0 : _seperatedAssessments5.length) > 0 ? /*#__PURE__*/React.createElement("td", null, _this.props.printable == true || _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.assignment.locked || seperatedAssessments.teacherAssessments == null || ((_seperatedAssessments6 = seperatedAssessments.teacherAssessments) === null || _seperatedAssessments6 === void 0 ? void 0 : _seperatedAssessments6.length) <= 0 ? null : _this.studentAssessmentButton(user)) : null, ((_seperatedAssessments7 = seperatedAssessments.peerAssessments) === null || _seperatedAssessments7 === void 0 ? void 0 : _seperatedAssessments7.length) > 0 ? peerAssessment == null ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(StudentAssessorSelect, {
          options: _this.props.assignment.tasks,
          disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.printable == true || _this.props.assignment.locked || disabled,
          name: "studentAssessor",
          item: user,
          defaultValue: user.studentAssessorId != null ? user.studentAssessorId : null,
          onChange: function onChange(event) {
            _this.onStudentAssessorChange(event, user);
          },
          placeholder: _this.props.translate('select-student'),
          section: _this.props.activeSection
        })) : /*#__PURE__*/React.createElement("td", null, (peerAssessment === null || peerAssessment === void 0 ? void 0 : peerAssessment.status) == 'ASSESSMENT_STARTED' ?
        /*#__PURE__*/
        // (<span className="simple-select__label">
        // 	<span className="simple-select__color" style={{backgroundColor: 'rgb(238, 193, 87)'}}></span>
        // 	{this.props.translate('Assessment started')}
        // </span>)
        React.createElement(SimpleSelect, {
          selectedValue: peerAssessment != null ? peerAssessment.status : '',
          name: "assessment-status",
          disabled: true,
          item: user,
          type: "assessment"
        }) : /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: function onClick() {
            return _this.openStudentAssessment(user, peerAssessment);
          }
        }, studentAssessor != null ? _this.props.translate('assessed-by') + ' ' + studentAssessor.groupName : _this.props.translate('show-assessment'))) : null, ((_seperatedAssessments8 = seperatedAssessments.selfAssessments) === null || _seperatedAssessments8 === void 0 ? void 0 : _seperatedAssessments8.length) > 0 ? /*#__PURE__*/React.createElement("td", null, selfAssessment != null ? /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: function onClick() {
            return _this.openStudentAssessment(user, selfAssessment);
          }
        }, _this.props.translate('show-assessment')) : /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          disabled: true
        }, _this.props.translate('show-assessment'))) : null, /*#__PURE__*/React.createElement("td", null, _this.props.assignment.created == '0001-01-01T00:00:00' || disabled ? null : /*#__PURE__*/React.createElement("div", null, user.workspace ? /*#__PURE__*/React.createElement(Link, {
          to: getRootUrl() + 'assignment/' + _this.props.assignment.id + '/task/' + user.id + '/documents',
          style: {
            cursor: 'pointer'
          }
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "File"
        }), !linkTextVisible && /*#__PURE__*/React.createElement("span", null, " ".concat(_this.props.translate('view-files'))))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert_Red"
        }), !linkTextVisible && /*#__PURE__*/React.createElement("span", null, " ".concat(_this.props.translate('view-files')))))), /*#__PURE__*/React.createElement("td", null, _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.printable == true || disabled ? null : /*#__PURE__*/React.createElement("div", null, user.workspace ? /*#__PURE__*/React.createElement("a", {
          className: "sp-target-link button button-primary",
          style: {
            margin: 0
          },
          href: rootUrl + user.workspace,
          target: "_blank"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "Folder"
        }), !linkTextVisible && /*#__PURE__*/React.createElement("span", null, " ".concat(_this.props.translate('workspace'))))) : /*#__PURE__*/React.createElement("div", {
          title: _this.props.translate('Missing workspace')
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert_Red"
        }), !linkTextVisible && /*#__PURE__*/React.createElement("span", null, " ".concat(_this.props.translate('workspace')))))), _this.props.services.conversations ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
          to: "#",
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick(e) {
            return _this.markForConversation(user);
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: '1.75rem',
            position: 'relative'
          }
        }, conversation != null ? /*#__PURE__*/React.createElement(Icon, {
          name: "Message"
        }) : /*#__PURE__*/React.createElement(Icon, {
          name: "Message",
          bw: true
        }), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "badge"
        }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null))) : null);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeToSubmitted", function () {
      _this.setState({
        loading: true
      });

      var selectedUsers = _this.props.assignment.tasks.filter(function (t) {
        return t.selected;
      });

      var tasks = [];
      selectedUsers.forEach(function (user) {
        if (user.status == 'ASSIGNMENT_TASK_NOT_STARTED' || user.status == 'ASSIGNMENT_TASK_STARTED') {
          var promise = api.put('assignments/Student/Status?assignmentTaskId=' + user.id + '&status=ASSIGNMENT_TASK_SUBMITTED').then(function () {
            user.status = 'ASSIGNMENT_TASK_SUBMITTED';
          });
          tasks.push(promise);
        }
      });
      Promise.all(tasks).then(function () {
        _this.setState({
          loading: false
        });
      });

      if (tasks.length == 0) {
        _this.setState({
          loading: false
        });
      }
    });

    _this.state = {
      allSelected: false,
      assessmentOpen: false,
      studentAssessmentOpen: false,
      removeAssessments: false,
      assessTask: null,
      permissionLoading: false,
      selectedAssessment: null
    };

    _this.onCheckAll.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(UserAssignment, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$state$selectedA,
          _this$state$selectedA2,
          _seperatedAssessments9,
          _seperatedAssessments10,
          _seperatedAssessments11,
          _seperatedAssessments12,
          _seperatedAssessments13,
          _this$props$assignmen;

      var isTeacher = isUserTeacher(this.props.currentUser);
      var selectedUsers = this.props.assignment.tasks.filter(function (t) {
        return t.selected;
      });
      var unpublishedAssessment = null;

      if (this.props.assessments != null) {
        unpublishedAssessment = this.props.assessments.find(function (ass) {
          return ass.status != 'ASSESSMENT_PUBLISHED' && ass.assessorType == ASSESSMENT_TYPES.TEACHER;
        });
      }

      var disableAssessmentsButton = true;

      if (unpublishedAssessment != null) {
        disableAssessmentsButton = false;
      }

      var assessAllButtonError = false;
      var disableRemoveAssessmentButton = true;
      selectedUsers.forEach(function (user) {
        if (user.status == 'ASSIGNMENT_TASK_STARTED' || user.status == 'ASSIGNMENT_TASK_NOT_STARTED') {
          assessAllButtonError = true;
          return;
        }

        var studentId = user.students[0].userId;

        if (studentId != null) {
          var hasAssessment = null;

          if (_this2.props.assessments != null) {
            hasAssessment = _this2.props.assessments.findIndex(function (ass) {
              return ass.studentId == studentId && ass.assessorType == ASSESSMENT_TYPES.TEACHER;
            });
          }

          if (hasAssessment > -1) {
            assessAllButtonError = true;
            disableRemoveAssessmentButton = false;
          }
        }
      });
      var changeToSubmittedError = selectedUsers.some(function (user) {
        return user.status == 'ASSIGNMENT_TASK_STARTED' || user.status == 'ASSIGNMENT_TASK_NOT_STARTED';
      });
      var assessmentBlocks = null;
      var assessment = null;
      var seperatedAssessments = {
        peerAssessments: [],
        teacherAssessments: [],
        selfAssessments: []
      };

      if (this.props.blocks != null) {
        var _assessmentBlocks$fil;

        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
        seperatedAssessments.peerAssessments = (_assessmentBlocks$fil = assessmentBlocks.filter(function (block) {
          return block.assessmentType == ASSESSMENT_TYPES.PEER && block.resources.length > 0;
        })) === null || _assessmentBlocks$fil === void 0 ? void 0 : _assessmentBlocks$fil.sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
        seperatedAssessments.teacherAssessments = assessmentBlocks.filter(function (block) {
          return (block.assessmentType == ASSESSMENT_TYPES.TEACHER || block.assessmentType == null) && block.resources.length > 0;
        }).sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
        seperatedAssessments.selfAssessments = assessmentBlocks.filter(function (block) {
          return block.assessmentType == ASSESSMENT_TYPES.SELF && block.resources.length > 0;
        }).sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
      }

      if (selectedUsers.length == 1 && this.props.assessments != null) {
        assessment = this.props.assessments.find(function (assessment) {
          return assessment.studentId == selectedUsers[0].assignedTo && assessment.assessorType == ASSESSMENT_TYPES.TEACHER;
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.assessmentOpen,
        onClose: this.closeAssessment,
        title: this.props.translate('Assessment')
      }, /*#__PURE__*/React.createElement(AssessmentForm, {
        onClose: this.closeAssessment,
        onSubmit: this.onAssessmentSubmit,
        blocks: seperatedAssessments.teacherAssessments,
        initialValues: assessment,
        items: selectedUsers.map(function (selected) {
          return _objectSpread({
            firstname: selected.groupName
          }, selected);
        }),
        referenceType: "AssignmentTask",
        assessmentType: ASSESSMENT_TYPES.TEACHER
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.studentAssessmentOpen,
        onClose: this.closeStudentAssessment,
        title: ((_this$state$selectedA = this.state.selectedAssessment) === null || _this$state$selectedA === void 0 ? void 0 : _this$state$selectedA.assessorType) == ASSESSMENT_TYPES.PEER ? this.props.translate('buddy-assessment') : this.props.translate('self-assessment')
      }, /*#__PURE__*/React.createElement(AssessmentsConsumer, {
        fields: ((_this$state$selectedA2 = this.state.selectedAssessment) === null || _this$state$selectedA2 === void 0 ? void 0 : _this$state$selectedA2.assessorType) == ASSESSMENT_TYPES.PEER ? seperatedAssessments.peerAssessments : seperatedAssessments.selfAssessments,
        assessment: this.state.selectedAssessment,
        isStudent: !isTeacher
      })), /*#__PURE__*/React.createElement(Modal, {
        overridePrompt: true,
        isOpen: this.state.removeAssessments,
        type: "small",
        title: this.props.translate('Remove assessments'),
        onClose: function onClose() {
          return _this2.setState({
            removeAssessments: false
          });
        }
      }, /*#__PURE__*/React.createElement(ClearBlockAssessments, {
        items: selectedUsers.map(function (x) {
          return {
            assignedTo: x.assignedTo,
            groupName: x.groupName
          };
        }),
        assessments: this.props.assessments,
        section: this.props.activeSection,
        onAbort: function onAbort(reload) {
          if (reload) _this2.props.reload(true);

          _this2.setState({
            removeAssessments: false
          });
        }
      })), /*#__PURE__*/React.createElement("table", {
        className: "status-list"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        style: {
          padding: '1em 1.5em'
        }
      }, this.props.printable == true || this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked ? null : /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(event) {
          return _this2.onCheckAll(event);
        },
        value: this.state.allSelected
      })), /*#__PURE__*/React.createElement("th", null, this.props.translate('name')), /*#__PURE__*/React.createElement("th", null, this.props.translate('Status')), ((_seperatedAssessments9 = seperatedAssessments.teacherAssessments) === null || _seperatedAssessments9 === void 0 ? void 0 : _seperatedAssessments9.length) > 0 ? /*#__PURE__*/React.createElement("th", null, this.props.translate('assessment-status')) : null, this.props.printable == true || this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked || seperatedAssessments.teacherAssessments == null || ((_seperatedAssessments10 = seperatedAssessments.teacherAssessments) === null || _seperatedAssessments10 === void 0 ? void 0 : _seperatedAssessments10.length) <= 0 ? null : /*#__PURE__*/React.createElement("th", null, this.props.translate('Assessment')), ((_seperatedAssessments11 = seperatedAssessments.peerAssessments) === null || _seperatedAssessments11 === void 0 ? void 0 : _seperatedAssessments11.length) > 0 ? /*#__PURE__*/React.createElement("th", null, this.props.translate('Peer review')) : null, ((_seperatedAssessments12 = seperatedAssessments.selfAssessments) === null || _seperatedAssessments12 === void 0 ? void 0 : _seperatedAssessments12.length) > 0 ? /*#__PURE__*/React.createElement("th", null, this.props.translate('self-assessment')) : null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null), this.props.services.conversations ? /*#__PURE__*/React.createElement("th", null) : null)), /*#__PURE__*/React.createElement("tbody", null, this.renderBody(seperatedAssessments))), !this.props.printable ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
        disabled: selectedUsers.length == 0 ? true : false,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this2.handleLocked(selectedUsers, true);
        }
      }, this.state.permissionLoading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, this.props.translate('lock assignment')), /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.permissionLoading || selectedUsers.length == 0 ? true : false,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this2.handleLocked(selectedUsers);
        }
      }, this.state.permissionLoading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, this.props.translate('unlock assignment'))) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: selectedUsers.length == 0 || this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked || !changeToSubmittedError || this.state.loading,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this2.changeToSubmitted();
        }
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, this.props.translate('turn-in-selected')) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: selectedUsers.length == 0 || this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked || assessAllButtonError,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this2.openAssessment();
        }
      }, this.props.translate('assess-selected-students')) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked || disableAssessmentsButton,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this2.publishAllAssessments();
        }
      }, this.props.translate('publish-assessments')) : null, ((_seperatedAssessments13 = seperatedAssessments.peerAssessments) === null || _seperatedAssessments13 === void 0 ? void 0 : _seperatedAssessments13.length) > 0 && this.props.assignment.created != '0001-01-01T00:00:00' && this.props.printable == false && this.props.assignment.locked == false ? /*#__PURE__*/React.createElement(Button, {
        disabled: (_this$props$assignmen = this.props.assignment.tasks) === null || _this$props$assignmen === void 0 ? void 0 : _this$props$assignmen.every(function (t) {
          var _t$assessmentTypeRela;

          return (_t$assessmentTypeRela = t.assessmentTypeRelationships) === null || _t$assessmentTypeRela === void 0 ? void 0 : _t$assessmentTypeRela.some(function (s) {
            return s.assessmentType == ASSESSMENT_TYPES.PEER && s.assessor != null;
          });
        }),
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this2.openRandomizeStudentAssessors();
        }
      }, this.props.translate('assign-student-assessors')) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: disableRemoveAssessmentButton || this.props.assignment.created == '0001-01-01T00:00:00' || this.props.assignment.locked || this.state.loading,
        style: {
          marginLeft: '1rem',
          marginTop: '1rem'
        },
        onClick: function onClick() {
          return _this2.setState({
            removeAssessments: true
          });
        }
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, this.props.translate('Remove assessments')) : null);
    }
  }]);

  return UserAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    conversations: state.Conversation.referenceConversations,
    assignment: state.assignments.active_assignment,
    assessments: state.assessments.assessments,
    studentAssessments: state.assessments.studentAssessments,
    activeSection: state.assignments.section,
    translate: translate(state.Languages.translations),
    blocks: state.Blocks.reference
  };
}

export default connect(mapStateToProps, {
  addError: addError,
  createAssessments: createAssessments,
  updateAssessment: updateAssessment,
  updateAssessmentStatus: updateAssessmentStatus
})(UserAssignment);